<template>
  <v-card flat>
    <v-card-title class="headline grey lighten-2" style="padding: 5px">
      <v-layout justify-start align-center>
        <v-flex xs2 sm1>
          <v-btn @click="close" flat icon>
            <v-icon >close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10 sm11 title font-weight-light>
          {{title}}
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-card-text v-if="path === '/auth-setup'">
      Страница для подключения и настройки вашего смс провайдера. Для работы с приложением вы должны быть зарегистрированным у одного из провайдеров из списка.
      <br><br>
      <b>СМС провайдер</b><br>
      <ul>
        <li>СМС агрегатор - имя вашего провайдера. Вы можете выбрать RocketSMS или Imobis</li>
        <li>Логин - имя вашего пользователя у провайдера</li>
        <li>Пароль - пароль вашего пользователя у провайдера</li>
      </ul>
    </v-card-text>

    <v-card-text v-if="path === '/profile-setup'">
      Страница для настройки параметров синхронизации c Yclients и текста сообщения в СМС.
      <br><br>
      <ul>
        <li>Компания - отражены ваши доступные компании Yclients. Необходимо настроить каждую компанию из списка</li>
        <li>Текст СМС - текст сообщения, которое будет отправляться клиенту в смс. Ссылка на запись подставляется автоматически</li>
        <li>Статус и цвет записи при подтверждении - если клиент подтверит свою запись, на этот статус и цвет изменится запись в Yclients</li>
        <li>Статус и цвет записи при отмене - если клиент отменит свою запись, на этот статус и цвет изменится запись в Yclients</li>
      </ul>
    </v-card-text>

    <v-card-text v-if="path === '/page-setup'">
      Здесь вы можете настроить, как будет выглядеть страница подтверждения записи. Эта информация будет доступна клиенту во время подтверждения записи.
      По умолчанию страница имеет цвета Yclients.
      Если вы хотите использовать страницу с индивидуальным дизайном, то обратитесь к администратору.
      <br><br>
      <img height="512" width="288" src="https://res.cloudinary.com/evriday/image/upload/v1669652984/gConfirm_tsn1pe.gif">
      <br><br>
      <b>ИНФО</b><br>
      <ul>
        <li>Название компании - имя компании в шапке страницы. Если хотите использовать логотип, обратитесь к администратору</li>
        <li>Основной текст - текст сообщения для подтверждения записи</li>
        <li>Обозначение валюты - валюта стоимости услуг</li>
      </ul>
      <br>
      <b>КОНТАКТЫ</b><br>
      Данная информация используется, чтобы клиент мог связаться с вами наиболее удобным способом. Оставьте поле пустым, если не хотите использовать какой-либо канал связи.
      <ul>
        <li>Телефон - ваш контактный телефон</li>
        <li>Viber - ваш номер телефон для связи через Viber</li>
        <li>Telegram - ваше имя пользователя для связи через Telegram (указывается БЕЗ @ в начале)</li>
        <li>Instagram - ваше имя пользователя для связи через Instagram</li>
        <li>Вконтакте - ваше имя пользователя для связи через VK</li>
      </ul>
      <br>
      <b>АДРЕС</b><br>
      Помогите клиенту легко вас найти.
      <ul>
        <li>Станция метро - ближайшая к вам станция метро. Оставьте поле пустым, если нет такой.</li>
        <li>Адрес, основная информация - напишите свой адрес, название ТЦ, особые приметы местоположения</li>
        <li>Адрес, дополнительная информация - укажите этаж, номер помещения или другую полезную информацию</li>
      </ul>
      <br>
      <b>НАСТРОЙКА</b><br>
      <ul>
        <li>Перенос записи - активируйте, если хотите предложить клиенту перенести запись в случае отмены текущей записи</li>
        <li>Ссылка на перенос записи - укажите ссылку на вашу онлайн-запись</li>
      </ul>
      <br>
      <img height="512" width="288" src="https://res.cloudinary.com/evriday/image/upload/v1669652984/gCancel_vx9fqk.gif">
    </v-card-text>

    <v-card-text v-if="path === '/automation'">
      Настройте автоматическую синхронизацию и отправку сообщений.
      <ul>
        <li>Автоматизация - вкл/выкл автоматическую синхронизацию записей</li>
        <li>Тип - доступны 2 опции. Сегодня - записи синхронизируются за сегодняшнее число. Завтра - синхронизируются записи за завтрашнее число</li>
        <li>Время - желаемое время синхронизации (имейте в виду, что процесс не мгновенный и может занимать до 5 минут)</li>
        <li>Автоматические СМС - вкл/выкл автоотправку сообщений после синхронизации</li>
      </ul>
      <br><br>
      <b>Пример 1:</b>
      <br>
      Вы хотите отправлять вечером сообщения клиентам, которые будут завтра, вам подойдут следующие настройки:
      <ul>
        <li>Автоматизация - вкл</li>
        <li>Тип - завтра</li>
        <li>Время - 20:00</li>
        <li>Автоматические СМС - вкл</li>
      </ul>
      <br><br>
      <b>Пример 2:</b>
      <br>
      Каждое утро вы хотите синхронизировать записи на сегодня и отправлять сообщения самостоятельно:
      <ul>
        <li>Автоматизация - вкл</li>
        <li>Тип - сегодня</li>
        <li>Время - 09:00</li>
        <li>Автоматические СМС - выкл</li>
      </ul>
    </v-card-text>

    <v-card-text v-if="path === '/'">
      Основная страница приложения. Здесь вы можете синхронизировать записи с Yclients, отправить сообщения клиентам, увидеть подтвердил или отменил клиент запись
      <br><br>
      Доступные кнопки:<br>
      <v-layout justify-center align-center row wrap>
        <v-flex xs12><v-icon>sync</v-icon><span> - синхронизация записей с Yclients</span></v-flex>
        <v-flex xs12><v-icon>email</v-icon><span> - отправка сообщений всем клиентам</span></v-flex>
        <v-flex xs12><v-icon>send</v-icon><span> - отправка сообщения одному клиенту</span></v-flex>
      </v-layout>
      <br>
      <br>
      При нажатии на <v-icon>email</v-icon> сообщения будут отправлены всем клиентам, записи которых соответствуют следующим условиям:
      <br>
      <ul>
        <li>заполнено поле "Телефон"</li>
        <li>заполнено поле "Услуга"</li>
        <li>заполнено поле "Сотрудник"</li>
        <li>доступна кнопка отправки СМС </li>
      </ul>
    </v-card-text>
    <v-card-text v-if="path === '/payment'">
      Информация о вашей лицензии и способах оплаты
    </v-card-text>
    <v-card-text v-if="path === '/contact'">
      Способы связи с администратором приложения
    </v-card-text>
    <v-card-text v-if="path === '/account'">
      Настройки вашего аккаунта
      <br><br>
      <ul>
        <li>Основная компания - если у вас несколько филиалов, то эта компания будет отображаться первой на странице записей</li>
      </ul>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    title: ''
  }),
  computed: {
    path () {
      return this.$route.path
    }
  },
  created () {
    switch (this.path) {
      case '/':
        this.title = 'Главная'
        break
      case '/auth-setup':
        this.title = 'Авторизация'
        break
      case '/profile-setup':
        this.title = 'Профиль'
        break
      case '/page-setup':
        this.title = 'Страница подтверждения'
        break
      case '/payment':
        this.title = 'Оплата'
        break
      case '/contact':
        this.title = 'Контакты'
        break
      case '/automation':
        this.title = 'Автоматизация'
        break
      case '/account':
        this.title = 'Мой аккаунт'
        break
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    }
  }
}
</script>
